export default __webpack_public_path__ + "static/media/art_num_bg.b7976065.svg";